
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.aw-sticky')) document.body.classList.add('aw-has-sticky');

  document.querySelectorAll('[data-aw-product-root]').forEach(root => {
    const form = root.querySelector('[data-aw-product-form]');
    const select = root.querySelector('[data-aw-variant-select]');
    const price = root.querySelector('[data-aw-price]');
    const compare = root.querySelector('[data-aw-compare]');
    const stickyPrice = root.querySelector('[data-aw-sticky-price]');
    const stickyButtonPrice = root.querySelector('[data-aw-sticky-button-price]');

    if (select) {
      select.addEventListener('change', () => {
        const opt = select.options[select.selectedIndex];
        if (price) price.textContent = opt.dataset.price || '';
        if (stickyPrice) stickyPrice.textContent = opt.dataset.price || '';
        if (stickyButtonPrice) stickyButtonPrice.textContent = opt.dataset.price || '';
        if (compare) {
          const cr = Number(opt.dataset.compareRaw || 0);
          const pr = Number(opt.dataset.priceRaw || 0);
          if (cr > pr) {
            compare.textContent = opt.dataset.compare || '';
            compare.style.display = '';
          } else {
            compare.style.display = 'none';
          }
        }
      });
    }

    if (form) {
      form.addEventListener('submit', async (e) => {
        const btn = form.querySelector('[data-aw-buy]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        const old = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        try{
          const r = await fetch('/cart/add.js', {
            method:'POST',
            headers:{'Accept':'application/json'},
            body:new FormData(form)
          });
          if(!r.ok) throw new Error('cart');
          window.location.href='/checkout';
        }catch(err){
          btn.disabled=false;
          btn.textContent=old;
          form.submit();
        }
      });
    }

    root.querySelectorAll('[data-aw-scroll-buy]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const buyButton = form?.querySelector('[data-aw-buy]');
        if (form && buyButton && !buyButton.disabled) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(buyButton);
          else buyButton.click();
          return;
        }
        root.querySelector('[data-aw-offer]')?.scrollIntoView({behavior:'smooth',block:'center'});
      });
    });
  });


  document.querySelectorAll('[data-aw-carousel]').forEach(track => {
    const shell = track.closest('.aw-carousel-section');
    const prev = shell?.querySelector('[data-aw-carousel-prev]');
    const next = shell?.querySelector('[data-aw-carousel-next]');
    const dots = Array.from(shell?.querySelectorAll('[data-aw-carousel-dots] button') || []);
    const slides = Array.from(track.children);
    if (!slides.length) return;

    const slideStep = () => {
      const first = slides[0];
      return first.getBoundingClientRect().width + 18;
    };

    const updateDots = () => {
      const step = slideStep();
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step)));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -slideStep(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: slideStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => window.requestAnimationFrame(updateDots), { passive: true });
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      track.scrollTo({ left: slideStep() * i, behavior: 'smooth' });
    }));
    updateDots();
  });

  const zoomImages = Array.from(document.querySelectorAll(
    '.aw-hero-media img, .aw-media img, .aw-real-image img'
  ));

  if (zoomImages.length) {
    const lightbox = document.createElement('div');
    lightbox.className = 'aw-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Enlarged product image');
    lightbox.innerHTML = `
      <div class="aw-lightbox-frame">
        <img src="" alt="">
        <button class="aw-lightbox-close" type="button" aria-label="Close enlarged image">×</button>
      </div>`;
    document.body.appendChild(lightbox);

    const lightboxImage = lightbox.querySelector('img');
    const closeButton = lightbox.querySelector('.aw-lightbox-close');
    let returnFocus = null;

    const closeLightbox = () => {
      lightbox.classList.remove('is-open');
      document.body.classList.remove('aw-lightbox-open');
      lightboxImage.src = '';
      returnFocus?.focus();
    };

    zoomImages.forEach(img => {
      const wrapper = img.parentElement;
      if (!wrapper || wrapper.querySelector('.aw-zoom-button')) return;
      const button = document.createElement('button');
      button.className = 'aw-zoom-button';
      button.type = 'button';
      button.textContent = 'Enlarge';
      button.setAttribute('aria-label', `Enlarge ${img.alt || 'product image'}`);
      wrapper.appendChild(button);
      button.addEventListener('click', () => {
        returnFocus = button;
        lightboxImage.src = img.currentSrc || img.src;
        lightboxImage.alt = img.alt || 'Enlarged product image';
        lightbox.classList.add('is-open');
        document.body.classList.add('aw-lightbox-open');
        closeButton.focus();
      });
    });

    closeButton.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', event => {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
    });
  }
});
